// src/app/u2104Organization/components/form/u2104Role/U2104UseGetOrganizatonRoleHandlers.ts
export interface U3141UseLockChildLotChainHandlersParams<T = unknown> {
  doLockFn: (id: string, childLotChainId: string) => Promise<unknown>;
  onSuccess?: (row: T) => void;
  onError?: (errors: { error: unknown }) => void;
}

// Return type for useU2104UseGetOrganizatonRoleHandlers hook
export interface U3141UseLockChildLotChainHandlersReturn {
  lockChildLotChain: (id: string, childLotChainId: string) => void;
}

// Handlers for getting organization role
export function useU3141UseLockChildLotChainHandlers<T extends { id: string } = { id: string }>({
  doLockFn,
  onSuccess,
  onError,
}: U3141UseLockChildLotChainHandlersParams<T>): U3141UseLockChildLotChainHandlersReturn {
  const lockChildLotChain = async (id: string, childLotChainId: string) => {
    try {
      const response = (await doLockFn(id, childLotChainId)) as { data: { result: T } };
      const row: T = response.data.result;

      if (onSuccess) {
        onSuccess(row);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { lockChildLotChain };
}
